import React from 'react';

function SelectedPlaceCard({
  formData,
  duplicateError,
  existingPlaceInfo,
  onClear,
}) {
  return (
    <div className={`selected-place-info ${duplicateError ? 'duplicate-error' : ''}`}>
      <button
        type="button"
        className="clear-place-btn"
        onClick={onClear}
        title="Clear selected place"
      >
        ✕
      </button>
      <div className="selected-place-name">
        <strong>{formData.name}</strong>
      </div>
      <div className="selected-place-address">{formData.address}</div>
      {formData.category && (
        <div className="selected-place-category">{formData.category}</div>
      )}
      {duplicateError && (
        <div className="duplicate-error-message">
          {duplicateError}
        </div>
      )}
    </div>
  );
}

function ExistingPlaceWarning({ existingPlaceInfo }) {
  if (!existingPlaceInfo) return null;

  return (
    <div className="existing-place-warning">
      <div className="warning-icon">!</div>
      <div className="warning-content">
        <div className="warning-title">This place is on your other lists</div>
        <div className="warning-lists">
          {existingPlaceInfo.lists.map((list, index) => (
            <span key={list.listId}>
              {list.listName}{index < existingPlaceInfo.lists.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
        <div className="warning-note">
          If you change the designation, it will change on all relevant lists.
        </div>
      </div>
    </div>
  );
}

export { SelectedPlaceCard, ExistingPlaceWarning };
